import React from "react";
import styles from "../css/adverseEvent.module.scss";
import { adverseEventStatsCards } from "../helper/adverseeventconstant";
import { AESummaryStats } from "../helper/adverseevent.types";

interface AESummaryCardsProps {
    stats?: AESummaryStats;
    loading?: boolean;
}

const AESummaryCards: React.FC<AESummaryCardsProps> = ({ stats, loading }) => {
    if (loading) return (
        <div className={styles.statsGrid}>
            {[1, 2, 3, 4].map(i => (
                <div key={i} className={styles.statCard} style={{ opacity: 0.6 }}>
                    <div className="placeholder-glow">
                        <div className="placeholder col-1 mb-2" style={{ height: "36px", width: "36px", borderRadius: "10px" }}></div><br />
                        <div className="placeholder col-6 mb-2" style={{ height: "12px", borderRadius: "10px" }}></div><br />
                        <div className="placeholder col-2" style={{ height: "12px", borderRadius: "10px" }}></div>
                    </div>
                </div>
            ))}
        </div>
    );


    return (
        <div className={`${styles.statsGrid} mb-3`}>
            {adverseEventStatsCards(stats)?.map((card: any, index: any) => (
                <div key={index} className={styles.statCard}>
                    <div
                        className={styles.iconWrapper}
                        style={{ backgroundColor: card.iconBg, color: card.iconColor }}
                    >
                        <i className={card.icon} />
                    </div>
                    <div className={styles.label}>{card.label}</div>
                    <div className={styles.value}>{card.value.toLocaleString()}</div>
                </div>
            ))}
        </div>
    );
};

export default AESummaryCards;
